import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';

class TableComponent extends React.PureComponent {
  getClassNames = () => {
    const alignFirstColumnLeft = this.props.alignFirstColumnLeft ? ' infStat-table-firstColumnLeft' : '';
    const contentWidth = this.props.contentWidth ? ' flex' : '';
    return `infStat-table${alignFirstColumnLeft}${contentWidth}`;
  }

  render () {
    return (
      <table className={this.getClassNames()}>
        <tbody>
          <tr>
            {map(this.props.tableHeaders, (tableHeader, i) =>
              <th key={i}>
                {tableHeader}
              </th>
            )}
          </tr>
          {map(this.props.tableData, (tableRow, i) =>
            <tr key={i}>
              {map(tableRow, (tableCell, j) =>
                <td key={j}>
                  {tableCell}
                </td>
              )}
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

TableComponent.propTypes = {
  tableHeaders: PropTypes.array.isRequired,
  tableData: PropTypes.array.isRequired,
  alignFirstColumnLeft: PropTypes.bool,
  contentWidth: PropTypes.bool
};

export default TableComponent;
